import { trackEvent } from 'user-analytics';
import createSeatRequest from 'api/createSeatRequest';
import { setError } from '.';

/**
 * Submit a "Negativa de Concessão de Benefício" request.
 * Sends beneficiary data plus the search context (origin, destination, date).
 * On success dispatches a success notification; on failure, an error notification.
 *
 * @param {object} values - Form values.
 * @param {string} values.name - Beneficiary full name.
 * @param {string} values.taxpayerId - Beneficiary CPF (11 digits).
 * @param {string} values.email - Beneficiary email.
 * @param {string} values.birthDate - Birth date in YYYY-MM-DD format.
 * @param {object} tripContext - Trip context for the negativa.
 * @param {string} tripContext.origin - Origin id.
 * @param {string} tripContext.destination - Destination id.
 * @param {string} tripContext.date - Travel date (YYYY-MM-DD).
 * @param {string} tripContext.category - Selected benefit category.
 * @returns {Function} Redux thunk.
 */
function submitSeatRequest(values, tripContext) {
  return async (dispatch) => {
    const payload = {
      passenger_name: values.name,
      document: values.taxpayerId,
      email: values.email,
      birth_date: values.birthDate,
      origin_id: tripContext.origin,
      destination_id: tripContext.destination,
      trip_date: tripContext.date,
      category: tripContext.category,
    };

    try {
      const response = await createSeatRequest(payload);
      trackEvent('Negativa Submitted', {
        origin: tripContext.origin,
        destination: tripContext.destination,
        date: tripContext.date,
      });
      dispatch(setError(200, 'negativa_emitida', 'success', false));
      return response;
    } catch (error) {
      trackEvent('Negativa Submission Failed', {
        origin: tripContext.origin,
        destination: tripContext.destination,
        date: tripContext.date,
        message: error?.message,
      });
      dispatch(setError(500, 'negativa_failed', 'error', false));
      throw error;
    }
  };
}

export default submitSeatRequest;
